<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">营销</a></el-breadcrumb-item>
          <el-breadcrumb-item>拼团</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="groupBooking" label-width="160px">
        <el-form-item label="拼团名称">
          <el-col :span="12">
            <el-input v-model="groupBooking.title" ></el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="产品">
          <el-col :span="12">
            <el-input v-model="productName" readonly placeholder="请选择产品">
              <el-button slot="append" icon="el-icon-search" @click="ShowDialogProductSelect"></el-button>
            </el-input>   
          </el-col>
        </el-form-item>
        <el-form-item label="拼团价">
          <el-col :span="12">
            <el-input v-model="groupBooking.groupPrice" >
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>  
        </el-form-item>        
        <el-form-item label="结算金额">
          <el-col :span="12">
            <el-input v-model="groupBooking.settlementAmount" >
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>          
        </el-form-item>
        <el-form-item label="成团人数">
          <el-col :span="12">
            <el-input v-model="groupBooking.needPeople" >
              <el-button slot="append" >人</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="单人限购">
          <el-col :span="12">
            <el-tooltip class="item" effect="dark" content="0表示不限制购买数量" placement="right">
              <el-input v-model="groupBooking.limitNumber" >
                <el-button slot="append" >份</el-button>
              </el-input>
            </el-tooltip>
          </el-col>
        </el-form-item>
        <el-form-item label="成团时间">
          <el-col :span="12">
            <el-tooltip class="item" effect="dark" content="在规定时间内未完成拼团，则拼团失败" placement="right">
              <el-input v-model="groupBooking.limitTime" >
                <el-button slot="append" >小时</el-button>
              </el-input>
            </el-tooltip>
          </el-col>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-col :span="12">
            <el-date-picker
              v-model="groupBooking.beginTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="结束时间">
           <el-date-picker
              v-model="groupBooking.endTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="上架">
          <el-col :span="12">
            <el-switch
              v-model="groupBooking.putOnShelves"
              >
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="背景音乐">
          <el-col :span="12">
            <el-upload
              class="upload-demo"
              :action="uploadMusicUrl"
              :on-success="handleUploadSuccess"
              :headers="headers">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            {{groupBooking.music}}
          </el-col>
        </el-form-item>  
        <el-form-item label="分享描述">
          <el-col :span="12">
            <el-input type="textarea" v-model="groupBooking.shareDescription"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item >
          <el-col :span="12">
            <el-button type="primary" @click="SavegroupBooking">保 存</el-button>
            <el-button style="margin-left: 8px" @click="handleBack">返回列表</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>    
    <GetProduct v-bind:dialogProduct="dialogProduct" @UpdateProduct="UpdateProduct"></GetProduct>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  import GetProduct from '@/components/GetProduct'
  export default {
    props:{
    },
    data (){
      return {
        uploadMusicUrl: this.global.serverSrc+'/api/Common/UploadFile',
        groupBooking:{},
        productName:"",        
        dialogProduct:{
          isShow:false
        },
        headers:{
          Authorization : sessionStorage.getItem('token')
        }
      }
    },
    computed:{      
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/groupBooking/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.groupBooking = resp.data.groupBooking
        that.productName = resp.data.productName
      })
    },
    methods:{     
      SavegroupBooking:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/groupBooking/Save',         
          data: that.groupBooking
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      UpdateProduct(id,name){
        this.groupBooking.productId = id
        this.productName = name
        this.dialogProduct.isShow = false
      },
      ShowDialogProductSelect(){
        this.dialogProduct.isShow = true
      },
      handleUploadSuccess(res, file){
        this.groupBooking.music= res.fullUrl
      },      
      handleBack(){
        var that = this
        this.$confirm('请先确定已经保存内容！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$router.push({
            name: 'groupBooking',
            params: {
              queryParam: that.$route.params.queryParam
            }
          })
        }).catch(() => {
            
        });
      }
    },
    components:{
      GetProduct
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
</style>